import { ModalDialog } from '@/shared/ui/modal-dialog';
import styles from './index.module.sass';
import { ButtonPrimary } from '@/shared/ui/button';
import { SelectBunker } from './components/select';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PlusSvg from '@/modules/mixing/images/plus.svg';
import DeleteSvg from '@/modules/mixing/images/delete.svg';
import { MultipleOption } from './components/multiple-option';
import { TypeToggler } from './components/type-toggler';
import { SingleOption } from './components/single-option';
import { useBunkers } from './hooks';
import { useStore } from 'effector-react';
import { $topRecipesForWarehouse } from '@/widgets/recipe/model';
import { setSelectedMix } from '../../store/recipes.store';
import { notification } from 'antd';

export const SelectBunkerModal = ({
  recipeId,
  onClose,
  options,
  warehouseId,
  type,
  setType,
  selectedRecipe,
}: ISelectBunkerModal) => {
  // const [bunker, setBunker]: any = useState(null);

  const topRecipes = useStore($topRecipesForWarehouse);
  const selectedRecipeData =
    selectedRecipe !== -1
      ? topRecipes?.mixes.find((item) => item.id === selectedRecipe)
      : null;

  const {
    totalState,
    addSingleSectionItem,
    addMultiSectionItem,
    removeSingleSectionItem,
    removeMultiSectionItem,
    setMultiSectionItemValue,
    setSingleSectionItemValue,
    setInitialState,
  } = useBunkers();

  const navigate = useNavigate();
  // useEffect(() => {
  //   setInitialState();
  // }, []);

  return (
    <ModalDialog
      onClose={() => {
        setInitialState();
        onClose();
      }}
      contentClassName={styles.overflowNone}
      className={styles.selectModal}
      title="выбор техники Liliani для миксования"
      actionsClassName={styles.button__wrap}
      actions={
        <ButtonPrimary
          disabled={
            type === 1
              ? totalState.multiSection.some((item) =>
                  item.items.some((subItem) => subItem.id === 0),
                )
              : totalState.singleSection.some((item) => item.id === 0)
          }
          onClick={() => {
            if (!selectedRecipeData)
              return notification.error({
                message: 'Возникла непредвиденная ошибка. Некорректный микс',
              });
            setSelectedMix(selectedRecipeData);
            navigate(
              `/mixing/recipe/detail/${recipeId}?warehouse_id=${warehouseId}&bunker=${
                type === 1
                  ? JSON.stringify(
                      totalState.multiSection.map((item: any) =>
                        item.items.map((item: any) => item.id),
                      ),
                    )
                  : JSON.stringify(totalState.singleSection.map((item) => item.id))
              }`,
            );
          }}
          className={styles.modalButton}
          label={'продолжить'}
        />
      }
    >
      <TypeToggler
        items={[
          'миксование двухсекционными бункерами',
          'миксование односекционными бункерами',
        ]}
        activeItem={type}
        setActiveItem={(val) => setType(val)}
      />
      <span className={styles.selectLabel}>бункеры-перегрузчики Liliani</span>
      <div className={styles.bunkers__wrap}>
        {type === 1 ? (
          <>
            {totalState.multiSection.map((item, i) => (
              <MultipleOption
                isLast={totalState.multiSection.length === i + 1}
                removeMultiSectionItem={removeMultiSectionItem}
                key={i}
                num={i}
                addMultiSectionItem={addMultiSectionItem}
                setMultiSectionItemValue={setMultiSectionItemValue}
                options={options}
                item={item}
              />
            ))}
          </>
        ) : (
          <>
            {totalState.singleSection.map((item, i) => (
              <SingleOption
                isLast={totalState.singleSection.length === i + 1}
                removeSingleSectionItem={removeSingleSectionItem}
                key={i}
                num={i}
                addSingleSectionItem={addSingleSectionItem}
                setSingleSectionItemValue={setSingleSectionItemValue}
                options={options}
                item={item}
              />
            ))}
          </>
        )}
      </div>
    </ModalDialog>
  );
};

interface ISelectBunkerModal {
  recipeId: number;
  options: {
    label: string;
    tonnage: number | string;
    value: number | string;
  }[];
  onClose: () => void;
  warehouseId: string;
  type: number;
  setType: (val: number) => void;
  selectedRecipe: number;
}
